import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT, saveCard } from '../../../constants/globalConstants'
import { getCardDataList, removeCardData, createCardData, makeDefaultCardData } from '../../../redux/actions/cardDetailsAction'
import { encryptionHandler, validExpiryDate, validFiservExpiryDate } from '../../../utils/helper'
import { Circles } from 'react-loader-spinner'
import ConfermationModal from '../../../components/global/ConfermationModal'
import AddCardModal from '../../../components/global/addCardModal'
import AdminListTablePage from '../../../components/global/dataTable'
import { renderNoResults } from '../../../components/global/NoDataFound'
import { errorMessage } from '../../../constants/errorMessage'
import MakedefaultModalForm from '../../../components/global/MakedefaultModalForm'
// import MessageModal from '../../../components/global/MessageModal'

import moment from 'moment/moment'
import CONSTANTS from '../../../redux/constants'
import { addEventLog } from '../../warningCitation/redux/actions/EventsLog'

function PaymentSetting(props) {
    const { current_page, per_page, dispatch, total, partnerDetails, notify } = props
    const [cardList, setCardList] = useState(EMPTY_ARRAY)
    const [expiry, setExpiry] = useState()
    const [card, setCard] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessages, setErrorMessage] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [error, setError] = useState(false)
    const [cardError, setCardError] = useState('')
    const [payload, setPayload] = useState(saveCard)
    const [isModalOpen, setModal] = useState(false)
    const [confermationModal, setConfermationModal] = useState(false)
    // const [displayModal, setDisplayModal] = useState(false)
    const [deleteItem, setDeleteItem] = useState(EMPTY_ARRAY)
    const [search, setSearch] = useState('')
    const [displayError, setDisplayError] = useState(null)
    const [makedefaultModal, setMakedefaultModal] = useState(false)
    const [defaultItem, setDefaultItem] = useState(EMPTY_ARRAY)
    const [deleteConfirmMessage, setDeleteConfirmMessage] = useState('Are you sure you want to delete?')
    
    // EOS-973
    const [isFiservGateway, setIsFiservGateway] = useState(false)
    const tokenRef = useRef(null)
    const [cardToken, setCardToken] = useState('')
    const [iframeErrorMsg, setIframeErrorMsg] = useState('')

    const isDefaultRef = useRef('0')
    const APILoad = useRef(true)
    // EOS-973

    // const [isConsent, setIsConsent] = useState(true)

    const columns = [
        { header: 'Card Number', id: 'card_number', accessor: e => e?.card_last_four ? `XXXX XXXX XXXX ${e?.card_last_four}` : '-' },
        { header: 'Expiry Date', id: 'expiry_Date', accessor: e => (e?.expiry !== null && e?.expiry != '') ? <><span className={(checkExpired(e?.expiry) || e?.is_expired == 1) ? 'text-danger fw-bold' : ''}>{e?.expiry?.slice(0, 2)}/{e?.expiry?.slice(-2)}</span>{(checkExpired(e?.expiry) || e?.is_expired == 1) ? <span className='fw-bold border border-danger text-danger d-inline-block p-1 ms-sm-1 rounded-1 small'>Expired</span> : ''}</> : '-' },
        { header: 'Actions', accessor: e => renderRowActions(e) }
    ]

    const checkExpired = (dt) => {
        let yr = dt?.slice(-2)
        let mt = dt?.slice(0, 2)
        // console.log(yr, mt)
        const inputDate = moment('20'+yr+'-'+mt+'-15', 'YYYY-MM-DD')
        const currentDate = moment()
        // Compare year first
        if (inputDate.year() > currentDate.year()) {
            return false
        } else if (inputDate.year() < currentDate.year()) {
            return true
        } else {
            return inputDate.month() < currentDate.month()
        }
    }

    useEffect(() => {
        // Check if this is Fiserv payment gateway
        const paymentTypeId = partnerDetails?.facilities?.[0]?.facility_payment_details?.facility_payment_type_id         
        setIsFiservGateway(paymentTypeId == '3')
    },[EMPTY_ARRAY, partnerDetails])

    const renderRowActions = (data) => {
        return (
            <div className={`${(data?.is_default == '0') ? 'd-flex' : 'h-100'} action-btn`}>
                {
                    ((cardList?.length > 1 || (validExpiryDate(expiry) || data?.is_expired == 1)) && (data?.is_default == '0' || validExpiryDate(expiry) || data?.is_expired == 1)) ? 
                    // (cardList?.length > 1) ? 
                    <a title="Delete" className="mt-0 ms-2 text-danger" href="#" onClick={(event) => {
                        event.stopPropagation()
                        event.preventDefault()
                        handleRemoveCard(event, data?.id)
                    }}>
                        <i className="fa  fa-trash"></i>
                    </a>:''
                }
                {(data?.is_default == '0' && !(validExpiryDate(expiry) || (data?.is_expired && data?.is_expired == 1))) ? 
                
                <a title="Make this default" href="#" className="mt-0 ms-2 text-gray" onClick={(event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    handleDefaultCard(event, data)
                }}>
                    <i className="fa-regular fa-check-circle text-gray opacity-50"></i>
                </a> : null }
                
                {data?.is_default == '0' ? null : <span className='ml-2 ms-2 mt-2 mt-sm-0 small h-100 gap-1 flex-sm-row justify-content-center justify-content-sm-start align-items-center  '>
                    <i className="text-success fa-regular fa-check-circle "></i>
                    <small className='text-nowrap ms-2 ml-2'>Default Card</small>
                </span>}
            </div>
        )
    }


    useEffect(() => {
        paymentListData()
        
    }, [EMPTY_ARRAY])


    const paymentListData = () => {
        setIsLoading(true)
        setSearch(search)
        // const facility_id = partnerDetails?.facilities?.[0]?.id
        dispatch(getCardDataList()).then((res) => {
            if(res?.data?.payments && res?.data?.payments != null){
                setCardList(res?.data?.payments)
                setIsLoading(false)
            }else{
                setIsLoading(false)
                setCardList(EMPTY_ARRAY)
                setDisplayError(res?.errors && res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
            }
        }).catch((err) => {
            setIsLoading(false)
            setDisplayError(err?.errors && err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
        })
    }

    const handleInputFieldsData = (e) => {
        const { name, value } = e.target
        setPayload({ ...payload, [name]: value })
    }

    const handleisDefault = () => {
        setPayload({ ...payload, is_default: (payload?.is_default == '0') ? '1' : '0' })
        isDefaultRef.current = (payload?.is_default == '0') ? '1' : '0'
    }

    const handleCardChange = (value) => {
        setCard(value?.trim())
        payload['card_number'] = value?.trim()
        setPayload({ ...payload })
    }

    const handleExpiryChange = (value) => {
        setExpiry(value?.trim())
        payload['expiration_date'] = value?.trim()
        setPayload({ ...payload })
        setCardError('')
    }

    const handleRemoveCard = (e, item) => {
        e.preventDefault()
        const cardToDelete = cardList?.filter((card) => card?.id == item)
        if(cardToDelete?.[0]?.is_default && cardToDelete?.[0]?.is_default == 1){
            setDeleteConfirmMessage('You’re about to delete your default card, which may affect ongoing payments. Please add and set a new default card. Do you wish to continue?')
        }else{
            setDeleteConfirmMessage('Are you sure you want to delete?')
        }
        setDeleteItem(item)
        setConfermationModal(true)
    }

    const handleDefaultCard = (e, item) => {
        e.preventDefault()
        setDefaultItem(item)
        setMakedefaultModal(true)
    }

    const handleDefault = () => {
        setIsLoading(true)
        const payload = {
            'id': defaultItem?.id,
            'user_id': defaultItem?.user_id,
            'is_default': 1,
            'expiry': defaultItem?.expiry ? defaultItem.expiry : '',
            'card_last_four': defaultItem?.card_last_four ? defaultItem.card_last_four : ''
        }
        dispatch(makeDefaultCardData(payload)).then((res) => {
            setIsLoading(false)
            setMakedefaultModal(false)
            if (res?.status === 201 && res?.data !== null) {
                notify('success', 'Card Updated')   
                paymentListData()
            }else {
                notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
            }
        }).catch((errors) => {
            setIsLoading(false)
            setMakedefaultModal(false)
            notify('error', errors?.message ? errors?.message : 'Something went wrong, Please try again!')
        })
    }

    // Delete Vehicle item
    const handleDelete = () => {
        if (deleteItem) {
            setIsLoading(true)
            let cardDetails = cardList.filter((crd) => {
                return crd.id === deleteItem
            })
            const deleteCardPayload = {
                // facility_id: partnerDetails?.facilities?.[0]?.id,
                id: deleteItem,
                expiry: cardDetails?.[0]?.expiry ? cardDetails?.[0]?.expiry : '',
                card_last_four: cardDetails?.[0]?.card_last_four ? cardDetails?.[0]?.card_last_four : ''
            
            }
            dispatch(removeCardData(deleteCardPayload)).then((res) => {
                setIsLoading(false)
                setConfermationModal(false)
                if (res?.status === 201 && res?.data !== null) {
                notify('success', 'Card Deleted')   
                paymentListData()
                }else {
                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                }
            }).catch((errors) => {
                setIsLoading(false)
                setConfermationModal(false)
                notify('error', errors?.message ? errors?.message : 'Something went wrong, Please try again!')
            })
        }
    }

    const handleSubmit = (data = null) => {
        setError(true)
        if (isFiservGateway) {
            // Check for Fiserv tokenizer errors first
            if (iframeErrorMsg) {
                notify('error', iframeErrorMsg)
                return
            }
            
            if (!cardToken) {
                notify('error', 'Please complete card information in the form above.')
                return
            }
            
            let expiryDateCheck = validFiservExpiryDate(cardToken?.expiry)
            if(!expiryDateCheck) {
                notify('error', 'Please enter a valid expiry date')
                return
            }

            setIsLoading(true)

            // Process Fiserv token data
            const tokenizedCard = {
                card_number: cardToken?.message || cardToken?.token,
                expiration_date: cardToken?.expiry || '',
                security_code: cardToken?.cvv || '',
            }

            const nonce = encryptionHandler(tokenizedCard)
           
            const cardData = {
                nonce: nonce,
                payment_type: 'credit_card',
                savePaymentMethod: true,
                gateway_type: 'fiserv',
                facility_id: partnerDetails?.facilities?.[0]?.id
            }

            if(payload?.is_default == '1' || cardList?.length == 0) {
                cardData.is_default = '1'
            }
            console.log('cardData fiserv--', cardData)

            dispatch(createCardData(cardData)).then((res) => {
                APILoad.current = true
                if (res?.data) {
                    notify('success', 'Card Added Successfully')
                    setPayload({ card_number: '', expiration_date: '' })
                    setCard('')
                    setExpiry('')
                    setIsEdit(false)
                    setModal(false)
                    setError(false)
                    paymentListData()
                    saveCard.is_default = 0
                    setPayload(saveCard)
                } else {
                    notify('error', res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong)
                    setIsLoading(false)
                    let errObject = {
                        payload: cardData,
                        error: res,
                        errorMessage: res?.errors?.message ? res?.errors?.message : errorMessage?.somethingWentWrong
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} addcard-Fiserv-PaymentGatewayDC.js`))
                }
            }).catch((err) => {
                APILoad.current = true
                notify('error', err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong)
                paymentListData()
                setIsLoading(false)
                let errObject = {
                    payload: cardData,
                    error: err,
                    errorMessage: err?.errors?.message ? err?.errors?.message : errorMessage?.somethingWentWrong
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} addcard-Fiserv-PaymentGatewayDC.js`))
            })
            return
        }else{
            let expiryDateCheck = validExpiryDate(payload?.expiration_date)
            if(!expiryDateCheck && partnerDetails?.facilities?.[0]?.facility_configuration?.is_iframe_enabled != '1') {
                setCardError('Please enter a valid expiry date')
            }
            if ((Object.values(payload)?.length > 0 && payload?.card_number &&  payload?.card_number?.length >= 15 && payload?.card_number?.length <= 16 && payload?.expiration_date && payload?.security_code && payload?.name_on_card && expiryDateCheck && (!payload?.zip_code_on_card || payload?.zip_code_on_card.length>4)) || (partnerDetails?.facilities?.[0]?.facility_configuration?.is_iframe_enabled == '1' && data)) {
                if(payload?.zip_code_on_card) {
                    payload.zip_code = payload?.zip_code_on_card
                }
                const nonce = encryptionHandler(payload)

                // let formData = new FormData()    //formdata object
                // formData.append('nonce', nonce)   //append the values with key, value pair
                // formData.append('payment_type', 'credit_card')   //append the values with key, value pair
                // formData.append('is_auto_deduction', 0)   //append the values with key, value pair

                setIsLoading(true)
                setErrorMessage('')

                const finalPayload = {
                    'payment_type': 'credit_card', 
                    'savePaymentMethod': true,
                    // 'facility_id': partnerDetails?.facilities?.[0]?.id,
                }
                if(partnerDetails?.facilities?.[0]?.facility_configuration?.is_iframe_enabled == '1') {
                    finalPayload.paymentToken = data
                    finalPayload.gateway_type = partnerDetails?.facilities?.[0]?.facility_payment_details?.facility_payment_type_id == '2' ? 'datacap' : partnerDetails?.facilities?.[0]?.facility_payment_details?.facility_payment_type_id == '3' ? 'fiserv' : partnerDetails?.facilities?.[0]?.facility_payment_details?.facility_payment_type_id == '4' ? 'heartland' : ''
                } else {
                    finalPayload.nonce = nonce
                }
                if(payload?.is_default == '1' || cardList?.length == 0) {
                    finalPayload.is_default = '1'
                }  else if (isDefaultRef.current == '1') {
                    finalPayload.is_default = '1'
                } else {
                    finalPayload.is_default = '0'
                }
                dispatch(createCardData(finalPayload)).then((res) => {
                    APILoad.current = true
                    if (res?.data !== null) {
                        notify('success' , 'Card Added Successfully')
                        setPayload({ card_number: '', expiration_date: '' })
                        setCard('')
                        setExpiry('')
                        setIsEdit(false)
                        setModal(false)
                        setError(false)
                        paymentListData()
                        saveCard.is_default = 0
                        setPayload(saveCard)
                    } else if (res?.data === null && res?.errors?.message) {
                        // saveCard.is_default = 0
                        // setPayload(saveCard)
                        // setErrorMessage(res?.errors?.message)
                        notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                        setIsLoading(false)
                    }
                }).catch((err) => {
                    APILoad.current = true
                    // saveCard.is_default = 0
                    // setPayload(saveCard)
                    // setErrorMessage(err?.errors?.message)
                    notify('error' , err?.errors?.message ? err?.errors?.message : 'Something went wrong, Please try again!')
                    setIsLoading(false)
                })
            } else {
                APILoad.current = true
                setIsLoading(false)
                setErrorMessage('')
            }
        }
    }

    const handleModalOpen = () => {
        setModal(true)
    }

    // const handleAutoPayChange = () => {

    //     setIsConsent(!isConsent)

    // }


    return (
        <div>
            <div className="d-flex justify-content-between mb-2 p-2 ">
                <h4 className="fw-bold">Payment Settings </h4>
                <button className="btn btn-primary ms-auto" onClick={handleModalOpen}><i className="fa fa-plus"></i> Add</button>
            </div>
            {isLoading ? <span className='ms-2 d-flex justify-content-center'><Circles
                height="50"
                width="50"
                color="var(--bs-primary)"
                ariaLabel="circles-loading"
                visible={true}
            /></span> :
                <div>
                    {/* <span className="switch-wrap">
                        <label className="switch">
                            <input type="checkbox" id='autopayconsent' name='autopayconsent' checked={isConsent} onChange={() => handleAutoPayChange()}/>
                            <span className="slider round"></span>
                        </label>
                        <label htmlFor="autopayconsent" > AutoPay Consent </label> <i className='ps-2 fa-sm fa fa-info-circle' onClick={() => setDisplayModal(true)}></i>
                    </span> */}

                    {cardList?.length > 0 ? <div className="card mb-sm-3">
                        <div className="card-header">  <b>Card List</b> </div>
                        <AdminListTablePage
                            data={cardList}
                            columns={columns}
                            getNewRecords={paymentListData}
                            curPage={current_page}
                            perPage={per_page}
                            total={total}
                            showSearch={false}
                            search={search}
                            hideSrnumber={true}
                        />
                    </div> : renderNoResults(displayError)}
                </div>
            
            }

            <AddCardModal cardList={cardList} isModalOpen={isModalOpen} setModal={setModal} payload={payload} modalName='Add New Card' isLoading={isLoading} handleCardChange={handleCardChange} handleExpiryChange={handleExpiryChange} handleSubmit={handleSubmit} expiry={expiry} card={card} errorMessage={errorMessages} isEdit={isEdit} error={error} setErrorMessage={setErrorMessage} setError={setError} setCard={setCard} setExpiry={setExpiry} handleInputFieldsData={handleInputFieldsData} handleisDefault={handleisDefault} partnerDetails={partnerDetails} cardError={cardError} isFiservGateway={isFiservGateway}
            setFiservToken={setCardToken} setIframeErrorMsg={setIframeErrorMsg} faciltyData={partnerDetails?.facilities?.[0]} tokenRef={tokenRef} setIsLoading={setIsLoading} APILoad={APILoad} />
            <ConfermationModal setConfermationModal={setConfermationModal} confermationModal={confermationModal} confermationHeading='Confirm Delete' confermationMessage={deleteConfirmMessage} buttonLable='Delete' handleDelete={handleDelete} />
            <MakedefaultModalForm setMakedefaultModal={setMakedefaultModal} makedefaultModal={makedefaultModal} makeDefaultHeading='Set Default Payment Method' confermationMessage='Do you wish to set this as your default Payment Method?' buttonLable='Confirm' handleDefault={handleDefault} />
            {/* <MessageModal setDisplayModal={setDisplayModal} displayModal={displayModal} modalHeading='Autopay Policy' modalMessage='Policy Message' /> */}
        </div>
    )
}

PaymentSetting.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    current_page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
}

PaymentSetting.defaulProps = {
    dispatch: noop,
    loader: PropTypes.bool,
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
}
function mapStateToProps({ cardDetailsReducer, PartnerReducer }) {
    const { current_page, per_page, total, loader } = cardDetailsReducer
    
    return {
        loader,
        current_page,
        per_page,
        total,
		partnerDetails: PartnerReducer?.partnerDetails?.data,

    }
}
export default connect(mapStateToProps)(PaymentSetting)